import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { userInformationAtom } from '../../Services/_states';
import { tenantAtom } from '../state/tenantAtom';

function mapOrganisationToTenant(org = {}) {
  if (!org || typeof org !== 'object') return null;

  const themeConfig = {
    primary_color: org.primary_color || org.theme_primary_color,
    secondary_color: org.secondary_color || org.theme_secondary_color,
    background_color: org.background_color || org.theme_background_color,
    chat_primary_color: org.chat_primary_color,
    mode: org.theme_mode,
    density: org.theme_density,
  };

  Object.keys(themeConfig).forEach((key) => {
    if (themeConfig[key] == null || themeConfig[key] === '') {
      delete themeConfig[key];
    }
  });

  return {
    organisation_name: org.organisation_name || org.name || 'Machadalo',
    logo_url: org.logo_url || org.logo || null,
    favicon_url: org.favicon_url || org.favicon || null,
    theme_config: themeConfig,
  };
}

/**
 * Hydrates tenantAtom from authenticated organisation profile.
 * Mount once near the app shell (ThemeProvider).
 */
export default function useTenantHydration() {
  const userInfo = useRecoilValue(userInformationAtom);
  const setTenant = useSetRecoilState(tenantAtom);

  useEffect(() => {
    const org = userInfo?.profile?.organisation;
    const mapped = mapOrganisationToTenant(org);
    if (!mapped) return;

    setTenant((prev) => ({
      ...prev,
      organisation_name: mapped.organisation_name || prev.organisation_name,
      logo_url: mapped.logo_url ?? prev.logo_url,
      favicon_url: mapped.favicon_url ?? prev.favicon_url,
      theme_config: {
        ...prev.theme_config,
        ...mapped.theme_config,
      },
    }));
  }, [setTenant, userInfo?.profile?.organisation]);
}
